// Import the functions you need from the SDKs you need
import { AppSettings } from '@/shared/app-common';
import { getApps, initializeApp } from 'firebase/app';
import { getAnalytics, isSupported } from 'firebase/analytics';

const isProd =
  process.env.NODE_ENV === 'production' && !process.env.NEXT_APP_API_HOST.includes('https://www-test.erasa.net');

// Initialize Firebase
// 立即执行模式：当此模块被导入时，Firebase 会自动初始化
function initFirebase() {
  const apps = getApps();

  if (!apps.length) {
    const app = initializeApp(AppSettings.firebaseConfig);

    // 只在生产环境且浏览器环境中初始化 Analytics
    // if (isProd && typeof window !== 'undefined') {
    if (typeof window !== 'undefined') {
      isSupported().then((yes) => {
        if (yes) {
          getAnalytics(app);
        }
      });
    }
  }
}

// 立即执行初始化
// 当 _app.tsx 导入此模块时，Firebase 会自动初始化
initFirebase();
